<template>
  <section class="recommended-products">
    <div v-if="loading" class="recommended-products__status" role="status">
      <b-spinner small aria-hidden="true" /> Cargando recomendaciones...
    </div>
    <div v-else-if="loadError" class="recommended-products__status" role="status">
      No pudimos cargar los productos recomendados.
      <button type="button" class="btn btn-link" @click="load">Reintentar</button>
    </div>
    <div v-else-if="!productList.length" class="recommended-products__status" role="status">
      Aún no hay productos recomendados.
    </div>
    <div v-else class="recommended-products__grid">
      <div v-for="product in productList" :key="product._id" class="recommended-products__item">
        <single-product :data="product" product-template="category-showcase" />
      </div>
    </div>
    <slot></slot>
  </section>
</template>

<script>
const singleProduct = () => import(/* webpackChunkName: "singleproduct" */ "./singleProduct.vue");

export default {
  components: { singleProduct },
  props: {
    id: { type: [String, Number], default: null },
    params: { type: String, default: "" },
  },
  data() {
    return { products: [], loading: true, loadError: false };
  },
  computed: {
    webName() {
      return this.$store.state.info && this.$store.state.info.webName;
    },
    limit() {
      const entry = this.params.split(",")
        .map((part) => part.trim().split("="))
        .find(([key]) => key === "limit");
      const value = Number(entry && entry[1]);
      return Number.isFinite(value) && value > 0 ? Math.min(12, Math.floor(value)) : 4;
    },
    productList() {
      return this.products.slice(0, this.limit);
    },
  },
  mounted() {
    this.load();
  },
  watch: {
    webName(next, previous) {
      if (next && next !== previous) this.load();
    },
  },
  methods: {
    async load() {
      if (!this.webName) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.loadError = false;
      try {
        const response = await this.$http.get(`${this.webName}/product/recomended`);
        this.products = Array.isArray(response.data.data) ? response.data.data : [];
      } catch (error) {
        this.products = [];
        this.loadError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.recommended-products { padding: clamp(8px, 2vw, 28px) clamp(4px, 1.5vw, 20px); }
.recommended-products__grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: clamp(14px, 2vw, 28px); align-items: stretch; }
.recommended-products__item { min-width: 0; }
.recommended-products__status { display: flex; min-height: 250px; align-items: center; justify-content: center; gap: 8px; color: #66788b; text-align: center; }
@media (max-width: 991.98px) { .recommended-products__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 575.98px) { .recommended-products { padding: 8px 4px 18px; } .recommended-products__grid { grid-template-columns: minmax(0, 1fr); gap: 16px; } }
</style>
